import type { ComponentProps } from 'react'
import AnswerEngineResults from '@/app/(app)/tools/answer-engine-tester/components/AnswerEngineResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `answer` (Phase 3, Step 8 — Class A, dashboard-reuse).
 *
 * REUSES the public `AnswerEngineResults` with `variant="dashboard"`, which hides the
 * public-only chrome (PlatformCTA + the gradient services CTA). The platform route
 * (`/api/platform/tools/answer-engine`) runs the same lib and returns the same
 * `AnswerEngineResult`, so the dashboard `data` maps straight onto the component —
 * the dashboard now shows the full rich report (question callout, provider citation
 * grid, AI analysis, score breakdown with the component's own CATEGORY_COLORS,
 * competitor URLs, recommendations) instead of the generic panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still works.
 * Grade comes from `data.grade` via the reused component — never recomputed.
 * Render-layer only.
 */
export function AnswerDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof AnswerEngineResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <AnswerEngineResults result={result} variant='dashboard' />
    </div>
  )
}
